import { render, staticRenderFns } from "./TextItem.vue?vue&type=template&id=36f90030&scoped=true"
import script from "./TextItem.vue?vue&type=script&lang=js"
export * from "./TextItem.vue?vue&type=script&lang=js"
import style0 from "./TextItem.vue?vue&type=style&index=0&id=36f90030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f90030",
  null
  
)

export default component.exports